import { render, staticRenderFns } from "./EditFeedback.vue?vue&type=template&id=f92f674e&scoped=true&"
import script from "./EditFeedback.vue?vue&type=script&lang=js&"
export * from "./EditFeedback.vue?vue&type=script&lang=js&"
import style0 from "./EditFeedback.vue?vue&type=style&index=0&id=f92f674e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92f674e",
  null
  
)

export default component.exports